import React, { useEffect } from "react";
import { Redirect, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearDocNumbering } from "../Pages/CommonAppRedux/DocNumbering/docNumberingSlice";

const ProtectedRoute = ({ component: Component, permission, location, ...rest }) => {
  //   // props
  const permissions = useSelector((state) => state.auth.permissions);
  const isSuperuser = useSelector((state) => state.auth.isSuperuser);
  const { loadingDocNumberingNo } = useSelector((state) => state.docNumbering);

  const hasPermission = isSuperuser || permission === "" || permissions.some((perm) => permission.includes(perm));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearDocNumbering());
  }, [rest.path]);
  return (
    <>
      <Route
        {...rest}
        render={(props) =>
          hasPermission ? (
            <Component {...props} />
          ) : (
            <Redirect to={"/access-denied"} />
            // <Redirect to={{ pathname: "/", state: { from: location } }} />
          )
        }
      />
    </>
  );
};

export default React.memo(ProtectedRoute);
